<div class="modal-header border-bottom-0">
    <h4 class="modal-title text-weight-500 text-size-18" id="modal-basic-title">
        {{ title }}
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body py-3">
    <p class="text-size-18">{{ message }}</p>
</div>
<div class="modal-footer border-top-0">
    <button type="button" class="btn btn-outline-secondary text-size-16" (click)="closeModal()">
        {{ cancelText }}
    </button>
    <button type="button" class="btn amts-bg-el23 text-white text-size-16" (click)="confirm()">
        {{ confirmText }}
    </button>
</div>